import { render, staticRenderFns } from "./pdf-view.vue?vue&type=template&id=728dadca&"
import script from "./pdf-view.vue?vue&type=script&lang=js&"
export * from "./pdf-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports